









import Vue from 'vue';
import Navigation from '@/vue-components/nav/Navigation.vue';

export default Vue.extend({
  name: 'App',
  components: { Navigation }
}
);
